// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_main__JmU4- {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.styles_card__Z5Nm1 {
  position: absolute;
  margin-top: 272px !important;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 480px;
  height: 500px;
  border-radius: 12px;
}

.styles_documentoTextField__reYS0 {
  color: #18316e !important;
  font-family: "Inter";
}

.styles_containerUsuarioTextField__ec3k- {
  margin-top: 12px !important;
}

.styles_usuarioTextField__kYamH {
  color: #18316e !important;
  font-family: "Inter";
}

.styles_containerEmailTextField__9nYlF {
  margin-top: 12px !important;
}

.styles_emailTextField__Qw8TX {
  color: #18316e !important;
  font-family: "Inter";
}

.styles_containerSenhaTextField__jYHVT {
  margin-top: 12px !important;
}

.styles_senhaTextField__G3ilx {
  color: #18316e !important;
  font-family: "Inter";
}

.styles_containerConfirmarSenhaTextField__tuUuf {
  margin-top: 12px !important;
}

.styles_confirmarSenhaTextField__bg0VE {
  color: #18316e !important;
  font-family: "Inter";
}

.styles_botaoConfirmar__mkMlc {
  background-color: #18316e !important;
  margin-top: 32px !important;
  width: 32% !important;
  font-family: "Inter" !important;
  transition: all 0.3s ease !important;
  text-transform: none !important;
  font-weight: 300 !important;
}

.styles_titulo__ukaBH {
  font-family: "Inter";
  font-size: 1rem;
  color: #18316e;
}

.styles_botaoEnviar__-iAj2 {
  background-color: #18316e !important;
  margin-top: 32px !important;
  font-family: "Inter" !important;
  transition: all 0.3s ease !important;
  text-transform: none !important;
  font-weight: 300 !important;
}

.styles_botaoEnviar_disable__47jI5 {
  background-color: #a3a3a3 !important;
  color: #ffffff !important;
  font-family: "Inter" !important;
  font-weight: 300 !important;
  text-transform: none !important;
  margin-top: 32px !important;
}

.styles_botaoLimpar__xSKof {
  background-color: #ffffff !important;
  color: #464a53 !important;
  margin-top: 32px !important;
  font-family: "Inter" !important;
  transition: all 0.3s ease !important;
  text-transform: none !important;
  font-weight: 300 !important;
}

.styles_labelField__7b-mb {
  font-family: "Inter" !important;
  font-size: 12px;
}

.styles_tipoDocumentoCombo__L\\+uQz {
  font-size: 12px !important;
  font-family: "Inter" !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/CadastroAssociado/styles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,qBAAqB;EACrB,+BAA+B;EAC/B,oCAAoC;EACpC,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,+BAA+B;EAC/B,oCAAoC;EACpC,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,+BAA+B;EAC/B,2BAA2B;EAC3B,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B;EAC3B,+BAA+B;EAC/B,oCAAoC;EACpC,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;AACjC","sourcesContent":[".main {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n}\n\n.card {\n  position: absolute;\n  margin-top: 272px !important;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 480px;\n  height: 500px;\n  border-radius: 12px;\n}\n\n.documentoTextField {\n  color: #18316e !important;\n  font-family: \"Inter\";\n}\n\n.containerUsuarioTextField {\n  margin-top: 12px !important;\n}\n\n.usuarioTextField {\n  color: #18316e !important;\n  font-family: \"Inter\";\n}\n\n.containerEmailTextField {\n  margin-top: 12px !important;\n}\n\n.emailTextField {\n  color: #18316e !important;\n  font-family: \"Inter\";\n}\n\n.containerSenhaTextField {\n  margin-top: 12px !important;\n}\n\n.senhaTextField {\n  color: #18316e !important;\n  font-family: \"Inter\";\n}\n\n.containerConfirmarSenhaTextField {\n  margin-top: 12px !important;\n}\n\n.confirmarSenhaTextField {\n  color: #18316e !important;\n  font-family: \"Inter\";\n}\n\n.botaoConfirmar {\n  background-color: #18316e !important;\n  margin-top: 32px !important;\n  width: 32% !important;\n  font-family: \"Inter\" !important;\n  transition: all 0.3s ease !important;\n  text-transform: none !important;\n  font-weight: 300 !important;\n}\n\n.titulo {\n  font-family: \"Inter\";\n  font-size: 1rem;\n  color: #18316e;\n}\n\n.botaoEnviar {\n  background-color: #18316e !important;\n  margin-top: 32px !important;\n  font-family: \"Inter\" !important;\n  transition: all 0.3s ease !important;\n  text-transform: none !important;\n  font-weight: 300 !important;\n}\n\n.botaoEnviar_disable {\n  background-color: #a3a3a3 !important;\n  color: #ffffff !important;\n  font-family: \"Inter\" !important;\n  font-weight: 300 !important;\n  text-transform: none !important;\n  margin-top: 32px !important;\n}\n\n.botaoLimpar {\n  background-color: #ffffff !important;\n  color: #464a53 !important;\n  margin-top: 32px !important;\n  font-family: \"Inter\" !important;\n  transition: all 0.3s ease !important;\n  text-transform: none !important;\n  font-weight: 300 !important;\n}\n\n.labelField {\n  font-family: \"Inter\" !important;\n  font-size: 12px;\n}\n\n.tipoDocumentoCombo {\n  font-size: 12px !important;\n  font-family: \"Inter\" !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `styles_main__JmU4-`,
	"card": `styles_card__Z5Nm1`,
	"documentoTextField": `styles_documentoTextField__reYS0`,
	"containerUsuarioTextField": `styles_containerUsuarioTextField__ec3k-`,
	"usuarioTextField": `styles_usuarioTextField__kYamH`,
	"containerEmailTextField": `styles_containerEmailTextField__9nYlF`,
	"emailTextField": `styles_emailTextField__Qw8TX`,
	"containerSenhaTextField": `styles_containerSenhaTextField__jYHVT`,
	"senhaTextField": `styles_senhaTextField__G3ilx`,
	"containerConfirmarSenhaTextField": `styles_containerConfirmarSenhaTextField__tuUuf`,
	"confirmarSenhaTextField": `styles_confirmarSenhaTextField__bg0VE`,
	"botaoConfirmar": `styles_botaoConfirmar__mkMlc`,
	"titulo": `styles_titulo__ukaBH`,
	"botaoEnviar": `styles_botaoEnviar__-iAj2`,
	"botaoEnviar_disable": `styles_botaoEnviar_disable__47jI5`,
	"botaoLimpar": `styles_botaoLimpar__xSKof`,
	"labelField": `styles_labelField__7b-mb`,
	"tipoDocumentoCombo": `styles_tipoDocumentoCombo__L+uQz`
};
export default ___CSS_LOADER_EXPORT___;
